import { createAppStore } from '@store/createAppStore';

import { PreferredLaneT } from '../types';
import {
  CarrierCSPCustomersState,
  CarrierDetailsState,
  CarrierLoadHistoryState,
} from './types';

const [carrierDetailsStore, setCarrierDetailsStore, resetCarrierDetailsStore] =
  createAppStore<CarrierDetailsState>(
    {
      carrierDetails: null,
      isLoading: false,
      isError: false,
      carrierDocuments: [],
      carrierFuelSurcharge: null,
      carrierAdjustments: [],
      selectedCountry: 'US',
      carrierDetailsErrors: null,
      creationMode: false,
      carrierAdjustmentAccounts: [],
      carrierMaxLiability: [],
      carrierLiabilityTypes: [],
      maxLiabilityCustomers: [],
      maxLiabilityCustomerId: null,
      maxLiabilityCarrierId: null,
      maxLiabilityLoading: false,
      maxLiabilitySaving: false,
      preferredLanes: [],
      equipmentCategories: [],
      showDuplicateBanner: false,
    },
    'carrierDetailsStore',
  );

const [
  carrierLoadHistoryStore,
  setCarrierLoadHistoryStore,
  resetCarrierLoadHistoryStore,
] = createAppStore<CarrierLoadHistoryState>(
  {
    isLoading: false,
    isError: false,
    items: [],
    totalCount: 0,
  },
  'carrierLoadHistoryStore',
);

// @ts-expect-error debug console
window.carrierDetailsStore = { carrierDetailsStore };

export const updatePreferredLane = (
  id: number,
  data: Partial<PreferredLaneT>,
) => {
  setCarrierDetailsStore('preferredLanes', (lanes) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const idx = (lanes as PreferredLaneT[]).findIndex((v) => v.id === id);

    if (idx < 0) {
      return lanes;
    }

    const newLanes = [...lanes];
    newLanes[idx] = {
      ...newLanes[idx],
      ...data,
    };

    return newLanes;
  });
};

export const removePreferredLane = (id: number) => {
  setCarrierDetailsStore('preferredLanes', (lanes) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const idx = (lanes as PreferredLaneT[]).findIndex((v) => v.id === id);

    if (idx < 0) {
      return lanes;
    }

    const newLanes = [...lanes];
    newLanes.splice(idx, 1);

    return newLanes;
  });
};

const [carrierCSPCustomers, setCarrierCSPCustomers] =
  createAppStore<CarrierCSPCustomersState>(
    {
      isLoading: true,
      isError: false,
      errorMessage: '',
      cspCustomers: [],
      cspEnabledCustomers: [],
    },
    'carrierCSPCustomers',
  );

export {
  carrierDetailsStore,
  carrierLoadHistoryStore,
  resetCarrierDetailsStore,
  resetCarrierLoadHistoryStore,
  setCarrierDetailsStore,
  setCarrierLoadHistoryStore,
  carrierCSPCustomers,
  setCarrierCSPCustomers,
};
